import { render, staticRenderFns } from "./backendAdaptationVersion.vue?vue&type=template&id=0fc9bc02&scoped=true&"
import script from "./backendAdaptationVersion.vue?vue&type=script&lang=js&"
export * from "./backendAdaptationVersion.vue?vue&type=script&lang=js&"
import style0 from "./backendAdaptationVersion.vue?vue&type=style&index=0&id=0fc9bc02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9bc02",
  null
  
)

export default component.exports